import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dataSourceAllowList", "dataTestId", "disabled", "disableDeleteIcon", "error", "formControlProps", "heightOffsetAdjustment", "hideNestedDataSources", "maybeDataToken", "onClearInput", "onDataPropertySelected", "propertyFieldTypeAllowList", "propertyTypeAllowList", "requiredPermissionLevel", "readOnly", "StaticInput"];
import { cloneElement, useRef } from 'react';
import useDataPassingPanel from 'automation-ui-formula-editor/data-passing-panel/hooks/useDataPassingPanel';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { useDataPassingContext } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
import { DataPassingDispatchActionType } from 'automation-ui-formula-editor/data-passing-panel/constants/DataPassingActionConstants';
import SinglePropertyInputPropertyField from 'automation-ui-formula-editor/data-passing-panel/Inputs/singlePropertyInput/SinglePropertyInputPropertyField';
import { isDataToken } from 'automation-ui-formula-editor/data-sources/utils/isDataToken';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MaybeDataTokenInput = _ref => {
  let {
      dataSourceAllowList,
      dataTestId,
      disabled,
      disableDeleteIcon,
      error,
      formControlProps,
      heightOffsetAdjustment = 110,
      hideNestedDataSources,
      maybeDataToken,
      onClearInput,
      onDataPropertySelected,
      propertyFieldTypeAllowList,
      propertyTypeAllowList,
      requiredPermissionLevel,
      readOnly,
      StaticInput
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ref = useRef(null);
  const {
    bindToDataPanel,
    DataPassingVisualIndicator
  } = useDataPassingPanel();
  const {
    dispatch: dataPassingDispatch
  } = useDataPassingContext();
  const {
    formattedToken
  } = getTokenParts(maybeDataToken || '');
  const isDataTokenPresent = isDataToken(maybeDataToken);
  const handleDehydrateFromPanel = () => {
    dataPassingDispatch({
      type: DataPassingDispatchActionType.DEHYDRATE,
      payload: {}
    });
  };
  const onDataPropertySelectedCallback = selectedDataProperty => {
    handleDehydrateFromPanel();
    const {
      dataCoordinate
    } = selectedDataProperty;
    const {
      formattedToken: newFormattedToken
    } = getTokenParts(dataCoordinate);
    onDataPropertySelected(Object.assign({}, selectedDataProperty, {
      dataCoordinate: newFormattedToken
    }));
  };
  const handleBindToDataPanel = () => {
    return bindToDataPanel({
      onDataPropertySelectedCallback,
      refFromBindingComponent: ref,
      dataSourceAllowList,
      propertyTypeAllowList,
      propertyFieldTypeAllowList,
      requiredPermissionLevel,
      hideNestedDataSources
    });
  };
  const onFocus = !readOnly && !disabled ? handleBindToDataPanel : () => {};
  return /*#__PURE__*/_jsxs("div", {
    // PM: Use private-form__set to impersonate a UIFormControls vertical spacing
    // https://hubspot.slack.com/archives/C1WG3L3J6/p1711457921977169
    // eslint-disable-next-line hubspot-dev/no-private-classes
    className: "private-form__set",
    "data-test-id": "maybeDataTokenInput",
    children: [/*#__PURE__*/_jsx(DataPassingVisualIndicator, {
      heightOffsetAdjustment: heightOffsetAdjustment
    }), /*#__PURE__*/_jsx("div", {
      ref: ref,
      children: isDataTokenPresent ? /*#__PURE__*/_jsx(SinglePropertyInputPropertyField, Object.assign({
        "data-test-id": dataTestId,
        disabled: disabled,
        disableDeleteIcon: disableDeleteIcon,
        error: error,
        formattedToken: formattedToken,
        formControlProps: formControlProps,
        onClearInput: () => onClearInput(handleBindToDataPanel),
        readOnly: readOnly
        // PM: Rest props has to get passed down to keep accessability props flowing
      }, restProps)) : ( /*#__PURE__*/cloneElement(StaticInput, Object.assign({
        onFocus
      }, restProps)))
    })]
  });
};
export default MaybeDataTokenInput;